export default __webpack_public_path__ + "3f9eb3f0cdc790b43d041d00df685c83.png";